import { render, staticRenderFns } from "./ReviewMatchTransactionUpload.vue?vue&type=template&id=803c43b0&"
import script from "./ReviewMatchTransactionUpload.vue?vue&type=script&lang=js&"
export * from "./ReviewMatchTransactionUpload.vue?vue&type=script&lang=js&"
import style0 from "./ReviewMatchTransactionUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports